import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useIntl, defineMessages } from 'react-intl'
import { FilterSection } from '../FilterSection/FilterSection'
import { HAS_OPEN_HOUSES } from '../../../../constants/listings'
import { FilterCheckBox } from '../FilterCheckBox/FilterCheckBox'
import { selectFilter } from '../../../../store/selectors/filters'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.tours.heading',
    defaultMessage: 'Tours'
  },
  upcomingOpenHouses: {
    id: 'HomeSearch.listings.filters.tours.upcomingOpenHouses',
    defaultMessage: 'Upcoming open houses'
  }
})

export interface ToursProps {}

export const Tours = ({}: ToursProps) => {
  const intl = useIntl()
  const filters = useSelector(selectFilter)
  const [hasOpenHouses, setHasOpenHouses] = useState<boolean>(filters.hasOpenHouses === 'true')

  return (
    <FilterSection title={intl.formatMessage(MSG.heading)}>
      <fieldset>
        <FilterCheckBox
          name={HAS_OPEN_HOUSES}
          isChecked={hasOpenHouses}
          label={intl.formatMessage(MSG.upcomingOpenHouses)}
          onChange={e => setHasOpenHouses(e.target.checked)}
        />
      </fieldset>
    </FilterSection>
  )
}
